import { ImageOff } from "lucide-react";
import { useState } from "react";

import { cn } from "@/lib/utils";

interface Props {
  src: string | null;
  alt: string;
  className?: string;
}

// 공개 시공사례 사진 한 칸 — 바깥 주소일 수 있어 평범한 img · 없거나 깨지면 자리표시.
const PublicPhoto = ({ src, alt, className }: Props) => {
  const [broken, setBroken] = useState(false);
  if (!src || broken) {
    return (
      <span className={cn("flex items-center justify-center bg-muted text-muted-foreground", className)}>
        <ImageOff className="size-6" />
      </span>
    );
  }
  return (
    <img
      alt={alt}
      className={cn("object-cover", className)}
      loading="lazy"
      referrerPolicy="no-referrer"
      src={src}
      onError={() => setBroken(true)}
    />
  );
};

export default PublicPhoto;
